export const fmtMoney = (n, currency = "RD$") => {
  const v = Number(n || 0);
  return `${currency}${v.toLocaleString("es-DO", { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;
};

// Symbol per ISO currency code. Defaults to the code itself for unknown codes.
export const sym = (code) => {
  if (!code) return "RD$";
  const c = String(code).toUpperCase();
  return ({
    DOP: "RD$", USD: "US$", EUR: "€",
    USDT: "USDT ",
    MXN: "MX$", COP: "CO$", ARS: "AR$", CLP: "CL$",
    PEN: "S/", BRL: "R$",
  })[c] || `${c} `;
};

export const fmtDate = (iso) => {
  if (!iso) return "";
  try {
    return new Date(iso).toLocaleDateString("es-DO", {
      day: "2-digit", month: "short", year: "numeric"
    });
  } catch { return iso; }
};

export const fmtDateTime = (iso) => {
  if (!iso) return "";
  try {
    return new Date(iso).toLocaleString("es-DO", {
      day: "2-digit", month: "short", hour: "2-digit", minute: "2-digit"
    });
  } catch { return iso; }
};

export const errMsg = (e, fallback = "Algo salió mal") => {
  const d = e?.response?.data?.detail;
  if (!d) return e?.message || fallback;
  if (typeof d === "string") return d;
  if (Array.isArray(d)) return d.map(x => x?.msg || JSON.stringify(x)).join(" ");
  // Errores con código: el backend manda {code, message} cuando la pantalla
  // puede querer ramificar por el código. Sin esto, `String(d)` pintaba
  // «[object Object]» y el mensaje escrito para la persona se perdía.
  if (d?.message) return d.message;
  return String(d);
};

export const CATEGORIES = [
  { value: "Salario", icon: "Briefcase", color: "#10B981" },
  { value: "Freelance", icon: "Sparkles", color: "#38BDF8" },
  { value: "Inversión", icon: "TrendingUp", color: "#22D3EE" },
  { value: "Comida", icon: "UtensilsCrossed", color: "#F59E0B" },
  { value: "Transporte", icon: "Car", color: "#8B5CF6" },
  { value: "Entretenimiento", icon: "Music", color: "#F43F5E" },
  { value: "Servicios", icon: "Plug", color: "#3B82F6" },
  { value: "Compras", icon: "ShoppingBag", color: "#EC4899" },
  { value: "Salud", icon: "Heart", color: "#EF4444" },
  { value: "Educación", icon: "GraduationCap", color: "#A78BFA" },
  { value: "Otros", icon: "MoreHorizontal", color: "#94A3B8" },
];

export const catColor = (c) =>
  CATEGORIES.find((x) => x.value === c)?.color || "#8B5CF6";
